import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import ShipmentsModalWrapper from "./ShipmentsModalWrapper";

class CreateShipmentButton extends React.Component {
  render() {
    return (
      <ShipmentsModalWrapper {...this.props}>
        {(toggleCreateShipmentPopup) => (
          <button onClick={toggleCreateShipmentPopup} className="button button--white">
            Shipments
          </button>
        )}
      </ShipmentsModalWrapper>
    );
  }
}

CreateShipmentButton.propTypes = {
  order: OrderObject.isRequired,
  awaitingCallPending: PropTypes.bool.isRequired,
  currentUser: CurrentUserObject.isRequired
};

export default CreateShipmentButton; 